<template>
  <ClientOnly>
    <!-- Debug: Always show for testing -->
    <div
      v-if="true"
      ref="spinnerRef"
      class="route-loading-spinner"
      :class="{ 'route-loading-spinner--loading': isLoading }"
    >
      <div class="route-loading-spinner__inner">
        <div class="route-loading-spinner__dot"></div>
        <div class="route-loading-spinner__dot"></div>
        <div class="route-loading-spinner__dot"></div>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
  const spinnerRef = useTemplateRef<HTMLElement | null>('spinnerRef');

  const { isLoading } = useLoadingIndicator();

  const { x, y } = useMouse({
    type: 'client',
  });

  const xMouse = computed(() => {
    return x.value + 'px';
  });

  const yMouse = computed(() => {
    return y.value + 'px';
  });
</script>

<style lang="scss" scoped>
  .route-loading-spinner {
    position: fixed !important;
    z-index: 2147483647 !important;
    pointer-events: none !important;
    left: 50vw;
    top: 50vh;
    left: v-bind(xMouse);
    top: v-bind(yMouse);
    transform: translate(10px, 0px) !important;
    opacity: 0;

    padding: 10px;
    min-width: 50px;
    min-height: 50px;

    &--loading {
      opacity: 1;
    }

    &__inner {
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
    }

    &__dot {
      width: 8px;
      height: 8px;
      @apply bg-accent;
      border-radius: 50%;
      animation: route-loading-bounce 1.4s ease-in-out infinite both;

      &:nth-child(1) {
        animation-delay: -0.32s;
      }

      &:nth-child(2) {
        animation-delay: -0.16s;
      }

      &:nth-child(3) {
        animation-delay: 0s;
      }
    }
  }

  @keyframes route-loading-bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
